export const GENERIC_EMAIL_DOMAINS = ['gmail.com', 'hotmail.com', 'yahoo.com', 'outlook.com', 'me.com', 'icloud.com'];

/** `theme.ts`'s variant resolver draws a hairline on every Mantine button; `@blockit/ui` has none. */
export const BUTTON_HAIRLINE_CLASS = 'border-black';
export const BUTTON_OUTLINE_HAIRLINE_CLASS = 'border-foreground dark:border-foreground';

/**
 * The Zoom access pills. Mantine's `variant='light'` is a tint of the hue over the page, and the
 * brand `green` is an olive whose `tone` recipe in `@blockit/ui` is the saturated flat, not the
 * tint — so both halves are stated literally, measured off the Mantine render.
 */
export const ACCESS_BADGE_CLASS = {
  available: 'bg-[#eaf9c3] text-foreground dark:bg-[#36401f]',
  other: 'bg-gray-100 text-foreground dark:bg-[#1c2a33]',
};
